<p-floatlabel>
    <p-autocomplete #userAutocomplete
        [(ngModel)]="selectedUser" 
        [suggestions]="users"
        [showClear]="true"
        [forceSelection]="true"
        styleClass="w-100"
        inputStyleClass="form-control"
        [minLength]="3"
        (completeMethod)="loadUsers(selectedUser?.id, $event)"
        (onSelect)="onChangeSelectedUser()"
        (onClear)="onChangeSelectedUser()"
        optionLabel="displayName"
        inputId="label">
        <ng-template let-item pTemplate="item">
            <div>{{ item.displayName }}</div>
        </ng-template>
    </p-autocomplete>
    <label for="userAutocomplete">
        <app-label-content [isRequired]="isRequired">
            {{  l('::Responsible') }}
        </app-label-content>
    </label>
</p-floatlabel>
